import React, { useState } from 'react';

import styled from '@emotion/styled';

import { Spacer } from '@shared/components/helpers';
import { UserRole } from '@shared/types/user_role';

import { Panel } from '@admin/components/helpers/panel';
import { Roles } from '@admin/components/helpers/roles';
import { Pagination } from '@admin/components/pagination';
import { Spinner } from '@admin/components/spinner';
import { useTitle } from '@admin/hooks/use_title';
import { client } from '@admin/libraries/apollo';
import { usePaginatedConfigurationListQuery } from '@admin/schema';

import { Table } from './table';

const SpinnerWrapper = styled.div`
  display: flex;
`;

export const OpsAuditConfigurations: React.FC = () => {
  useTitle('Ops Audit Configurations');
  const [page, setPage] = useState<number | undefined>(undefined);
  const [includeDeleted, setIncludeDeleted] = useState(false);

  const { data, loading } = usePaginatedConfigurationListQuery({
    client,
    variables: { page, includeDeleted },
  });

  const paginated = data && data.paginated;
  return (
    <div className="ops-audit-configurations">
      <Panel>
        <Panel.Header>
          <Panel.Title>Ops Audit Tool</Panel.Title>
        </Panel.Header>
        <Panel.Body>
          <Roles show={[UserRole.Admin]}>
            <div className="form-group">
              <label>
                <input
                  type="checkbox"
                  checked={includeDeleted}
                  onChange={(e) => {
                    setIncludeDeleted(e.target.checked);
                    setPage(undefined);
                  }}
                />{' '}
                Include Deleted
              </label>
            </div>
          </Roles>
          <Spacer height="8px" />
          {loading && (
            <>
              <SpinnerWrapper>
                <Spinner />
              </SpinnerWrapper>
              <Spacer height="8px" />
            </>
          )}
          <Table configurations={(paginated && paginated.results) || []} includeDeleted={includeDeleted} page={page} />
          {paginated && <Pagination pagination={paginated.pagination} onPage={setPage} />}
        </Panel.Body>
      </Panel>
    </div>
  );
};
